import React, { Fragment, useEffect } from 'react';
import { Link } from '@zola/zola-ui/src/components/Link';
import { MailIcon } from '@zola/zola-ui/src/components/SvgIcons/Mail';
import { trackCtaClicked } from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import { fetchInquiryList, fetchUnrespondedMessages } from 'actions/InquiryActions';
import { connect, useSelector } from 'react-redux';
import { getHasInquiries, getUnrespondedMessageCount } from 'selectors/InquirySelectors';
import type { AppDispatch } from '../../../reducers';

const Messages: React.FC<{
  userId: string;
  handleFetchUnrespondedMessages: () => void;
  handlefetchInquiryList: () => void;
}> = ({ userId, handleFetchUnrespondedMessages, handlefetchInquiryList }) => {
  const unrespondedCount = useSelector(getUnrespondedMessageCount);
  const hasInquiries = useSelector(getHasInquiries);

  useEffect(() => {
    if (userId) {
      handleFetchUnrespondedMessages();
      handlefetchInquiryList();
    }
  }, [handleFetchUnrespondedMessages, handlefetchInquiryList, userId]);

  if (!hasInquiries) {
    return <Fragment />;
  }
  const svgDimensions = {
    title: 'Messages',
    height: 40,
    width: 40,
  };

  const handleClick = () => {
    trackCtaClicked({
      business_unit: 'MARKETPLACE',
      cta_id: 'MAIL_ICON',
      position: 1,
    });
  };

  const renderMessages = unrespondedCount ? (
    <span className="badge">{unrespondedCount}</span>
  ) : null;

  return (
    <Link
      className="icon-link nav-util__bell"
      tabIndex={0}
      aria-label="Your Messages"
      href="/wedding-vendors/inquiries/active"
      onClick={handleClick}
    >
      {renderMessages}
      <MailIcon className="nav-util__icon" {...svgDimensions} />
    </Link>
  );
};
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  handleFetchUnrespondedMessages: () => dispatch(fetchUnrespondedMessages()),
  handlefetchInquiryList: () => dispatch(fetchInquiryList()),
});

export default connect(null, mapDispatchToProps)(Messages);
